import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/groups'

export default {
    getGroups(groupName) {
        return axios.get(`${V1}${RESOURCE_NAME}`, {params: {name: groupName, Type: 'Region'}})
    },
}
